import React from "react";

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  className = "",
}) => (
  <div
    className={"ds-page-header " + className}
    style={{
      padding: "8px 4px 0",
      alignItems: "flex-start",
      display: "flex",
      // Umbrechen, sonst quetschen sich langer Titel und Actions auf schmalen
      // Viewports gegenseitig zusammen.
      flexWrap: "wrap",
      justifyContent: "space-between",
      gap: 16,
    }}
  >
    <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 0 }}>
      <h1 className="ds-page-title">{title}</h1>
      {subtitle && <div className="ds-page-sub">{subtitle}</div>}
    </div>
    {actions && (
      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          flexShrink: 0,
          marginTop: 4,
        }}
      >
        {actions}
      </div>
    )}
  </div>
);
